"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var vue_3 = require("vue");
var echarts = __importStar(require("echarts"));
var index_1 = require("@/store/index");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AuthorCharts',
    props: {
        countData: {
            type: Array,
            default: function () { return []; }
        },
        category: {
            type: Array,
            default: function () { return []; }
        },
    },
    setup: function (__props) {
        var props = __props;
        var mainStore = (0, index_1.useMainStore)();
        var dark = (0, vue_3.computed)(function () { return mainStore.isDark; });
        (0, vue_3.watch)(dark, function (_, next) {
            initCharts(next);
        });
        var myChart;
        var lineCharts = (0, vue_3.ref)();
        var initCharts = function (isDark) {
            var chartsTheme = isDark ? "light" : "dark";
            if (myChart) {
                myChart.dispose();
            }
            myChart = echarts.init(lineCharts.value, chartsTheme);
            var option;
            option = {
                title: {
                    text: '朝代作者数量统计（个）',
                    top: 10,
                    left: 10,
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        return "\n        \u671D\u4EE3\uFF1A".concat(params[0].name, " </br> \n        \u4F5C\u8005\u6570\u91CF\uFF1A").concat(params[0].value, "\u4E2A\n        ");
                    },
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                // grid: {
                //   left: '20',
                //   right: '20',
                //   bottom: '10',
                //   containLabel: true
                // },
                xAxis: {
                    type: 'category',
                    data: props.category,
                    // axisLabel: {
                    //   formatter: function (params) {
                    //     let maxLen = 8
                    //     if (params.length > maxLen) {
                    //       let val = params.substr(0, maxLen) + '...';
                    //       return val;
                    //     } else {
                    //       return params;
                    //     }
                    //   },
                    //   interval: 0,
                    //   // rotate: 45
                    // },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: props.countData,
                        type: 'bar',
                        barWidth: "30",
                        name: "作者总量",
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{c}',
                        },
                        itemStyle: {
                        // borderType: 'solid',
                        // borderColor: '#fff',
                        // shadowColor: '#fff',
                        },
                    }
                ]
            };
            option && myChart.setOption(option);
        };
        (0, vue_3.onMounted)(function () {
            initCharts(!mainStore.isDark);
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                ref_key: "lineCharts",
                ref: lineCharts,
                style: { "height": "100%", "width": "100%", "background-color": "white" },
                id: "main"
            }, null, 512));
        };
    }
});
